const updatePageTitle = function (title) {
  document.title = `${title} | Proxpect`;
};

export default {
  inserted: (el, binding) => updatePageTitle(binding.value || el.innerText),
  update: (el, binding) => updatePageTitle(binding.value || el.innerText),
  componentUpdated: (el, binding) => updatePageTitle(binding.value || el.innerText),
};
